import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, FormControl, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { checkModule } from "../../store/api/CommonFunctions";

export default function ModalExtendGuarantee() {
    const appModules = useSelector(state => state.SystemSettingsReducer.appModules);
    return (
        <Modal show={true} size="xl">
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCheckSquare} size="lg" />&nbsp;
                    تمدید گارانتی
                </span>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <div>
                    <label style={{ marginBottom: "3px", borderBottom: "1px solid", color: "blue", fontWeight: 700 }}>تعداد کاربران مجاز: {appModules.UserCount}</label>
                </div>
                <Row className="rowBorder module-container" style={{ padding: 20 }}>
                    <div className="rowTitle">
                        ماژول های فعال
                    </div>
                    {checkModule(appModules.Data, 2) &&
                        <Col md={12} style={{ width: "max-content" }}>اطلاعات پایه</Col>
                    }
                    {checkModule(appModules.Data, 4) &&
                        <Col md={12} style={{ width: "max-content" }}>مدیریت ارتباط با مشتریان</Col>
                    }
                    {checkModule(appModules.Data, 8) &&
                        <Col md={12} style={{ width: "max-content" }}>خدمات پس از فروش</Col>
                    }
                    {checkModule(appModules.Data, 16) &&
                        <Col md={12} style={{ width: "max-content" }}>امور مالی</Col>
                    }
                    {checkModule(appModules.Data, 32) &&
                        <Col md={12} style={{ width: "max-content" }}>اتوماسیون اداری</Col>
                    }
                    {checkModule(appModules.Data, 64) &&
                        <Col md={12} style={{ width: "max-content" }}>فروش</Col>
                    }
                    {checkModule(appModules.Data, 128) &&
                        <Col md={12} style={{ width: "max-content" }}>خزانه داری</Col>
                    }
                    {checkModule(appModules.Data, 256) &&
                        <Col md={12} style={{ width: "max-content" }}>انبار</Col>
                    }
                    {checkModule(appModules.Data, 512) &&
                        <Col md={12} style={{ width: "max-content" }}>تولید</Col>
                    }
                    {checkModule(appModules.Data, 1024) &&
                        <Col md={12} style={{ width: "max-content" }}>حقوق و دستمزد</Col>
                    }
                    {checkModule(appModules.Data, 2048) &&
                        <Col md={12} style={{ width: "max-content" }}>پروژه ها</Col>
                    }
                    {checkModule(appModules.Data, 4096) &&
                        <Col md={12} style={{ width: "max-content" }}>مدیریت نمایندگان</Col>
                    }
                    {checkModule(appModules.Data, 8192) &&
                        <Col md={12} style={{ width: "max-content" }}>نسخه تکنسین</Col>
                    }
                    {checkModule(appModules.Data, 16384) &&
                        <Col md={12} style={{ width: "max-content" }}>مدیریت اسناد</Col>
                    }
                    {checkModule(appModules.Data, 32768) &&
                        <Col md={12} style={{ width: "max-content" }}>دستورالعمل</Col>
                    }
                    {checkModule(appModules.Data, 65536) &&
                        <Col md={12} style={{ width: "max-content" }}>مشتریان VIP</Col>
                    }
                    {checkModule(appModules.Data, 131072) &&
                        <Col md={12} style={{ width: "max-content" }}>فاکتور خدمات</Col>
                    }
                    {checkModule(appModules.Data, 68719476736) &&
                        <Col md={12} style={{ width: "max-content" }}>ارتباط با WordPress</Col>
                    }
                    {checkModule(appModules.Data, 274877906944) &&
                        <Col md={12} style={{ width: "max-content" }}>ارتباط با شرکت مادر</Col>
                    }
                    {checkModule(appModules.Data, 262144) &&
                        <Col md={12} style={{ width: "max-content" }}>مانیتورینگ و مدیریت</Col>
                    }
                    {checkModule(appModules.Data, 524288) &&
                        <Col md={12} style={{ width: "max-content" }}>مدیریت پخش</Col>
                    }
                    {checkModule(appModules.Data, 1048576) &&
                        <Col md={12} style={{ width: "max-content" }}>کنترل گارانتی</Col>
                    }
                    {checkModule(appModules.Data, 2097152) &&
                        <Col md={12} style={{ width: "max-content" }}>باشگاه مشتریان</Col>
                    }
                    {checkModule(appModules.Data, 4194304) &&
                        <Col md={12} style={{ width: "max-content" }}>دارایی های ثابت</Col>
                    }
                    {checkModule(appModules.Data, 8388608) &&
                        <Col md={12} style={{ width: "max-content" }}>رضایت سنجی</Col>
                    }
                    {checkModule(appModules.Data, 16777216) &&
                        <Col md={12} style={{ width: "max-content" }}>شکایات</Col>
                    }
                    {checkModule(appModules.Data, 33554432) &&
                        <Col md={12} style={{ width: "max-content" }}>حمل و نقل</Col>
                    }
                    {checkModule(appModules.Data, 67108864) &&
                        <Col md={12} style={{ width: "max-content" }}>سامانه مودیان</Col>
                    }
                    {checkModule(appModules.Data, 134217728) &&
                        <Col md={12} style={{ width: "max-content" }}>گزارش ساز</Col>
                    }
                    {checkModule(appModules.Data, 268435456) &&
                        <Col md={12} style={{ width: "max-content" }}>جریان کار</Col>
                    }
                    {checkModule(appModules.Data, 536870912) &&
                        <Col md={12} style={{ width: "max-content" }}>مدیریت تماس ها</Col>
                    }
                    {checkModule(appModules.Data, 1073741824) &&
                        <Col md={12} style={{ width: "max-content" }}>پیامک ها</Col>
                    }
                    {checkModule(appModules.Data, 2147483648) &&
                        <Col md={12} style={{ width: "max-content" }}>یادآوری ها</Col>
                    }
                    {checkModule(appModules.Data, 4294967296) &&
                        <Col md={12} style={{ width: "max-content" }}>سرویس های دوره ای</Col>
                    }
                    {checkModule(appModules.Data, 8589934592) &&
                        <Col md={12} style={{ width: "max-content" }}>مدیریت رویدادها</Col>
                    }
                    {checkModule(appModules.Data, 17179869184) &&
                        <Col md={12} style={{ width: "max-content" }}>جوایز و هدایا</Col>
                    }
                    {checkModule(appModules.Data, 137438953472) &&
                        <Col md={12} style={{ width: "max-content" }}>بارکد</Col>
                    }

                </Row>
                <Row className="rowBorder" style={{ padding: "20px", justifyContent: "center", textAlign: "center" }}>
                    <div className="rowTitle">مدت گارانتی</div>
                    <Col><Button className="w-100 btn-dark-purple heart-animation" >یک ماه</Button></Col>
                    <Col><Button className="w-100 btn-dark-purple heart-animation">سه ماه</Button></Col>
                    <Col><Button className="w-100 btn-dark-purple heart-animation">6 ماه</Button></Col>
                    <Col><Button className="w-100 btn-dark-purple heart-animation">یک سال</Button></Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}